import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ConfiguracaoCustoVendaSalvarRequest } from '../../requests/suprimentos/configuracao-custo-venda-salvar.request';
import { ConfiguracaoCustoVendaResponse } from '../../responses/suprimentos/configuracao-custo-venda.response';
import { ConfiguracaoCustoVendaSalvarResponse } from '../../responses/suprimentos/configuracao-custo-venda-salvar.response';

@Injectable({ providedIn: 'root' })
export class ConfiguracaoCustoVendaService extends CommonService {
  private readonly apiUrl = `${environment.urlApiSuprimentos}ConfiguracaoCustoVenda`;

  constructor(private httpClient: HttpClient) { super(); }

  public get(): Observable<ConfiguracaoCustoVendaResponse> {
    return this.httpClient.get<ConfiguracaoCustoVendaResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public put(request: ConfiguracaoCustoVendaSalvarRequest): Observable<ConfiguracaoCustoVendaSalvarResponse> {
    return this.httpClient.put<ConfiguracaoCustoVendaSalvarResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

}
